import React from "react";
import LodgingPaymentsList from "./views/list";

export default function LodgingPaymentsPage() {
  return <LodgingPaymentsList />;
  /*const [submitDisabled, setSubmitDisabled] = useState(true);
  const [selectedDate, setSelectedDate] = useState();

  const form = useForm({ mode: "onChange" });

  const { control, watch } = form;
  const useLodgingPaymentStoreModel = createComponentStore(
    LodgingPaymentStoreModel
  );
  const [store, actions] = useLodgingPaymentStoreModel();

  const { fetch, create } = actions;

  useEffect(() => {
    onDateSelected(moment(new Date()));
  }, []);

  return (
    <PageHeader
      className={
        isScreenMobile() ? "mobile-customized customized" : "customized"
      }
      title="Lojman Kiraları Ödeme Listesi"
      extra={[
        <Button
          key="paid"
          type="primary"
          onClick={() => {
            tableData.forEach((d) => {
              handleSelectChange("PAID", d);
              form.setValue("paymentSelect_" + d.contractId, "PAID");
            });
          }}
        >
          Tümü Ödendi
        </Button>,
        <Button
          key="clear"
          type="danger"
          onClick={() => {
            tableData.forEach((d) => {
              form.setValue("paymentSelect_" + d.contractId, null);
              form.setValue("paymentDesc_" + d.contractId, null);
            });
          }}
        >
          Temizle
        </Button>,

        <Button
          style={{ width: 160, marginLeft: 10 }}
          onClick={handleOnSubmit}
          loading={store.process === ACTION_TYPES.CREATING_DATA}
          disabled={submitDisabled}
        >
          Kaydet
        </Button>,

        <DatePicker
          key="filter"
          picker="month"
          onChange={onDateSelected}
          defaultValue={moment(new Date())}
          placeholder="Ödeme listesini görüntülemek istediğiniz dönemi seçiniz."
          style={{ width: isScreenMobile() ? 120 : 450 }}
        />,
      ]}
    />
  );*/
}
